module.exports = __webpack_public_path__ + "img/ione_bank_logo.806dd873.svg";